import React from "react";
import optionIconGold from "@/assets/icons/optionIconGold.png";
import { MdChevronRight } from "react-icons/md";
import Image from "next/image";
import { putComma } from "@/lib/utils";

export default function StockDetailOHLC({ preData = {}, scriptData, activeChartType }) {
    const data = activeChartType == 1 ? scriptData?.["NSE"] : scriptData?.["BSE"];

    return (
        <>
            {preData?.optionChainAvailable && (
                <div className="rounded-xl border border-[#EDEDED] mx-4 mt-6 p-3 flex items-center gap-3  ">
                    <Image src={optionIconGold} alt="icon" width={88} height={88} className="w-11 object-contain" />
                    <div className="text-black font-Inter font-bold text-sm">{preData?.compName} Option Chain</div>
                    <MdChevronRight size={24} className="ml-auto" />
                </div>
            )}
            <div className=" lg:flex flex-col items-start gap-3 border border-[#E5E5E5] bg-[#FFF] p-3 rounded-xl border-solid mx-4 my-8 hidden ">
                <div className="flex justify-center items-start gap-4 self-stretch">
                    <div className="flex flex-col items-start gap-2 flex-[1_0_0]">
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Open</div>
                            <div className="text-black">{putComma(data?.todayOpen)}</div>
                        </div>
                        <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Prev.Close</div>
                            <div className="text-black">{putComma(data?.todayClose)}</div>
                        </div>
                    </div>
                    <div className="w-px h-[60px] bg-[#EDEDED]"></div>
                    <div className="flex flex-col items-start gap-2 flex-[1_0_0]">
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Low</div>
                            <div className="text-black">{putComma(data?.todayLow)}</div>
                        </div>

                        <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">High</div>
                            <div className="text-black">{putComma(data?.todayHigh)}</div>
                        </div>
                    </div>
                    <div className="w-px h-[60px] bg-[#EDEDED]"></div>
                    <div className="flex flex-col items-start gap-2 flex-[1_0_0]">
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Lower circuit</div>
                            <div className="text-black">{putComma(data?.lowerLimit)}</div>
                        </div>
                        <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Upper circuit</div>
                            <div className="text-black">{putComma(data?.upperLimit)}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-col items-start gap-3 border border-[#E5E5E5] bg-[#FFF] p-3 rounded-xl border-solid mx-4 my-8 lg:hidden">
                <div className="flex justify-center items-start gap-4 self-stretch">
                    <div className="flex flex-col items-start gap-2 flex-[1_0_0]">
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Open</div>
                            <div className="text-black">{data?.todayOpen ?? "0.00"}</div>
                        </div>
                        <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Low</div>
                            <div className="text-black">{data?.todayLow ?? "0.00"}</div>
                        </div>
                        <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Lower circuit</div>
                            <div className="text-black">{data?.lowerLimit ?? "0.00"}</div>
                        </div>
                    </div>
                    <div className="flex flex-col items-start gap-2 flex-[1_0_0]">
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Prev.Close</div>
                            <div className="text-black">{data?.todayClose ?? "0.00"}</div>
                        </div>
                        <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">High</div>
                            <div className="text-black">{data?.todayHigh ?? "0.00"}</div>
                        </div>
                        <div className="h-[0.5px] self-stretch bg-[#EDEDED]"></div>
                        <div className="flex justify-between items-start self-stretch font-Inter text-xs lg:text-sm font-medium leading-5">
                            <div className="text-[#979797]">Upper circuit</div>
                            <div className="text-black">{data?.upperLimit ?? "0.00"}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
